import type { DeliveryStatus } from "@mandoob/shared";

import { useLanguage } from "@/contexts/language";
import { cn } from "@/lib/utils";

// Small status pill for a delivery (شحنة), styled like the SessionPill so the
// two read as one family in list rows and the thread header.

const STATUS_STYLE: Record<DeliveryStatus, string> = {
  New: "tw:bg-info-soft tw:text-info",
  Ongoing: "tw:bg-warning-soft tw:text-warning",
  Delivered: "tw:bg-success-soft tw:text-success-foreground",
  Cancelled: "tw:bg-destructive-soft tw:text-destructive",
};

export const DELIVERY_STATUS_KEYS: Record<DeliveryStatus, string> = {
  New: "Mandoob:Delivery.StatusNew",
  Ongoing: "Mandoob:Delivery.StatusOngoing",
  Delivered: "Mandoob:Delivery.StatusDelivered",
  Cancelled: "Mandoob:Delivery.StatusCancelled",
};

export function DeliveryStatusBadge({
  status,
  className,
}: {
  status: DeliveryStatus;
  className?: string;
}) {
  const { t } = useLanguage();
  return (
    <span
      className={cn(
        // border-current: a slim outline in the same color as the label.
        "tw:inline-flex tw:shrink-0 tw:items-center tw:rounded-full tw:border tw:border-current tw:px-2.5 tw:py-0.5 tw:text-xs tw:font-medium tw:leading-[1.67]",
        STATUS_STYLE[status],
        className,
      )}
    >
      {t(DELIVERY_STATUS_KEYS[status])}
    </span>
  );
}
